import _ from 'lodash';
import React from 'react';
import {
  getAuth,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  get,
  update,
  push,
  child,
  // startAfter,
  limitToFirst,
  query as dbQuery,
  orderByChild,
  startAt,
  equalTo,
} from 'firebase/database';
import {
  getFirestore,
  doc,
  getDoc,
} from 'firebase/firestore';
import moment from 'moment-timezone';
import {
  all,
  takeLatest,
  fork,
  call,
  put,
  takeEvery,
  select,
  take,
} from 'redux-saga/effects';
import axios from 'axios';
import { notification } from '../../components';
import actions from './actions';
import authActions from '../auth/actions';
import profileActions from '../profile/actions';
import prescriptionsActions from '../prescriptions/actions';

const ROOT_URL = process.env.REACT_APP_CLOUD_FUNCTIONS_ROOT_URL;

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

const getIsProfessionalFromStore = (state) => state.Auth.professional;

const getUnifiedTokenStore = (state) => state.Auth.unified;

const getUserFromStore = (state) => state.Auth.user;

const getSeectedIdFromStore = (state) => state.Contacts.seectedId;

const getProfileFromStore = (state) => state.Profile.profileOnDB;

const getSelectedAddressFromStore = (state) => state.App.selectedAddress;

const getMainUserFromStore = (state) => state.Auth.mainUser;

const getHealthProfessionalFromStore = (state) => state.Auth.healthProfessional;

const getMemedUserTokenFromStore = (state) => state.Memed.memedUserToken;

const getMemedUserDataFromStore = (state) => state.Memed.memedUserData;

const getMemedSettingsFromStore = (state) => state.Memed.memedSettings;

const getCustomUserFromStore = (state) => state.CustomUsers.customUsers;

const getCustomHealthProfessionalProfileFromStore = (state) => _.cloneDeep(state.Profile.customHealthProfessionalProfile);

const getDeletedMemedUserFromStore = (state) => state.Memed.deletedMemedUser;

const getLastMemedItemFromStore = (state) => state.Memed.lastMemedItem;

const getMemedListFromStore = (state) => state.Memed.memedList;

function getIdToken() {
  const auth = getAuth();
  const { currentUser } = auth;
  return currentUser.getIdToken();
}

function getMemedSettingsFromDB(mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  return get(child(dbRef, `users/${uid}/memedSettings`));
}

export function* getMememedSettingsRequest() {
  yield takeLatest([
    authActions.LOGIN_SUCCESS,
    actions.FETCH_MEMED_SETTINGS_REQUEST,
    profileActions.PROFILE_INFO_SUCCESS,
  ], function* (action) {
    try {
      console.info('getMememedSettingsRequest', action);
      const professional = yield select(getIsProfessionalFromStore);
      if (professional) {
        let profile = yield select(getProfileFromStore);
        const mainUser = yield select(getMainUserFromStore);
        const healthProfessional = yield select(getHealthProfessionalFromStore);
        const memedSettings = yield call(getMemedSettingsFromDB, mainUser);
        // const defaultObj = {
        //   useMemed: false,
        // };
        if (_.isEmpty(profile)) {
          yield take(profileActions.PROFILE_INFO_SUCCESS);
          profile = yield select(getProfileFromStore);
        }
        const defaultObj = {};
        if (!mainUser) {
          defaultObj[profile.id] = {
            useMemed: (memedSettings.val() && memedSettings.val().useMemed) || false,
          };
        }
        if (mainUser && healthProfessional) {
          const customHealthProfessionalProfile = yield select(getCustomHealthProfessionalProfileFromStore);
          if (customHealthProfessionalProfile) {
            profile = _.cloneDeep(customHealthProfessionalProfile);
          }
          defaultObj[profile.id] = { useMemed: false };
        }
        let missingProfileInfo = false;
        if (!profile.cpf || !profile.birthday) {
          missingProfileInfo = true;
        }
        if ((missingProfileInfo && memedSettings.val()?.[profile.id]?.useMemed)
          || (profile?.council?.type !== 'crm' && profile?.council?.type !== 'cro' && memedSettings.val()?.[profile.id]?.useMemed)) {
          // yield put({
          //   type: actions.FETCH_MEMED_SETTINGS_SUCCESS,
          //   payload: {
          //     ...defaultObj,
          //   },
          // });
          yield put({
            type: actions.CHANGE_USE_MEMED_REQUEST,
            payload: {
              value: false,
              id: profile.id,
            },
          });
        } else if (memedSettings.val()) {
          const memedObj = {
            ...defaultObj,
            ...memedSettings.val(),
          };
          delete memedObj.useMemed;
          yield put({
            type: actions.FETCH_MEMED_SETTINGS_SUCCESS,
            payload: memedObj,
          });
          if (!memedObj?.[profile.id]?.useMemed) {
            yield all([
              put({
                type: actions.SELECT_THIRD_PARTY_MEMED_USER,
                payload: {
                  id: null,
                },
              }),
              put({
                type: actions.SET_MEMED_USER_TOKEN,
                payload: {
                  token: null,
                  user: null,
                },
              }),
            ]);
          }
        } else {
          yield put({
            type: actions.FETCH_MEMED_SETTINGS_SUCCESS,
            payload: {
              ...defaultObj,
            },
          });
        }
      }
    } catch (error) {
      console.warn(error);
    }
  });
}

function changeUseMemedOnDB({ value, id }, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  updates[`users/${uid}/memedSettings/${id}/useMemed`] = value;
  // return true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* changeUseMemedRequest() {
  yield takeLatest(actions.CHANGE_USE_MEMED_REQUEST, function* (action) {
    try {
      yield put({ type: actions.UPDATING_USE_MEMED });
      const mainUser = yield select(getMainUserFromStore);
      yield call(changeUseMemedOnDB, action.payload, mainUser);
      // yield put({
      //   type: actions.FETCH_MEMED_SETTINGS_REQUEST,
      // });
      yield all([
        // put({
        //   type: actions.SELECT_THIRD_PARTY_MEMED_USER,
        //   payload: {
        //     id: null,
        //   },
        // }),
        // put({
        //   type: actions.SET_MEMED_USER_TOKEN,
        //   payload: {
        //     token: null,
        //     user: null,
        //   },
        // }),
        put({
          type: actions.FETCH_MEMED_SETTINGS_REQUEST,
        }),
      ]);
    } catch (error) {
      console.warn(error);
      notification(
        'error',
        'Algo deu errado',
        'Tente novamente mais tarde.',
      );
      yield put({
        type: actions.CHANGE_USE_MEMED_ERROR,
      });
    }
  });
}

function registerMemedUser(idToken, mainUser, addressUid, profile) {
  // let uid;
  // if (mainUser) {
  //   uid = mainUser;
  // } else {
  //   const { currentUser } = firebase.auth();
  //   ({ uid } = currentUser);
  // }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const memedObj = {};
  // CRM and Email field are filled in later calls, because it's senstive fields (throw erros if already on Memed's database)
  memedObj.nome = profile.firstName;
  memedObj.sobrenome = profile.lastName;
  memedObj.data_nascimento = profile.birthday;
  memedObj.cpf = profile.cpf;
  // memedObj.email = profile.email;
  memedObj.email = null;
  if (profile.gender === 'male') {
    memedObj.sexo = 'M';
  } else if (profile.gender === 'female') {
    memedObj.sexo = 'F';
  } else {
    memedObj.sexo = '';
  }
  if (profile.council?.type === 'crm' || profile.council?.type === 'cro' || profile.council?.type === 'coren') {
    memedObj.board = {};
    memedObj.board.board_code = profile.council.type;
    memedObj.board.board_number = profile.council.value;
    memedObj.board.board_state = profile.council.region.toUpperCase();
  }
  const addressObj = profile.addresses.find((ad) => ad.id === addressUid);
  if (addressObj) {
    if (addressObj.city?.longName) {
      memedObj.cidade = addressObj.city.longName;
    }
    if (addressObj.state?.shortName) {
      memedObj.estado = addressObj.state.shortName;
    }
  }
  const bodyParameters = {
    uid: profile.id,
    memedObj,
  };
  console.info('bodyParameters registerMemedUser', bodyParameters);
  // return true;
  return axios.post(
    `${ROOT_URL}/registerMemedUser`,
    bodyParameters,
    config,
  );
}

export function* registerMemedUserRequest() {
  yield takeEvery(actions.REGISTER_MEMED_USER_REQUEST, function* (action) {
    const deletedMemedUser = yield select(getDeletedMemedUserFromStore);
    try {
      console.info('REGISTER_MEMED_USER_REQUEST', action);
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const healthProfessional = yield select(getHealthProfessionalFromStore);
      const customUsers = yield select(getCustomUserFromStore);
      const user = yield select(getUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      let profile = yield select(getProfileFromStore);
      if (_.isEmpty(profile)) {
        yield take(profileActions.PROFILE_INFO_SUCCESS);
        profile = yield select(getProfileFromStore);
      }
      if (mainUser) {
        const customHealthProfessionalProfile = yield select(getCustomHealthProfessionalProfileFromStore);
        if (!_.isEmpty(customHealthProfessionalProfile)) {
          profile = _.cloneDeep(customHealthProfessionalProfile);
        } else if (action.payload?.id && !healthProfessional) {
          // It is a non-professional account. Need to use the id provided through paylad.
          const selectedId = action.payload.id;
          if (selectedId === mainUser) {
            // Use the main profile.
          } else {
            const foundUser = customUsers.find((el) => el.id === selectedId);
            if (foundUser) {
              profile = _.cloneDeep(foundUser);
            }
          }
        }
      }
      const response = yield call(
        registerMemedUser,
        idToken,
        mainUser,
        addressUid,
        {
          ...profile,
          email: user.email,
        },
      );
      if (response?.data?.data?.attributes) {
        yield put({
          type: actions.GET_MEMED_USER_REQUEST,
        });
      }
    } catch (error) {
      console.warn(error);
      if (error?.response?.data?.errors && !deletedMemedUser) {
        // yield put({
        //   type: actions.DELETE_MEMED_USER_REQUEST,
        // });
        console.warn(error.response.data.errors);
      }
      const cpfError = error?.response?.data?.errors?.find((el) => el.code === 'CPF');
      if (cpfError) {
        notification(
          'error',
          'Ocorreu um erro com a Memed na hora de validar o seu CPF, entre em contato com o suporte',
          <div>
            <div>
              {`Mensagem de erro: ${cpfError.detail}`}
            </div>
            <div>
              <a href="https://ajuda.memed.com.br" target="_blank" rel="noopener noreferrer">Suporte Memed</a>
            </div>
          </div>,
          null,
        );
      } else if (error?.response?.data?.errors?.length > 0) {
        notification(
          'error',
          'Ocorreu um erro com a Memed na hora de realizar seu cadastro, entre em contato com o suporte',
          <div>
            {error.response.data.errors.map((e) => (
              <div key={`${e.code}-${e.detail}`}>
                {`• ${e.detail}`}
              </div>
            ))}
            <div>
              <a href="https://ajuda.memed.com.br" target="_blank" rel="noopener noreferrer">Suporte Memed</a>
            </div>
          </div>,
          null,
        );
      }
      yield put({
        type: actions.ERROR_UPDATING_MEMED_USER,
      });
    }
  });
}

function deleteMemedUser(idToken, mainUser, profile) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const memedObj = {};
  memedObj.cpf = profile.cpf;
  if (profile.council?.type === 'crm' || profile.council?.type === 'cro' || profile.council?.type === 'coren') {
    memedObj.councilAndUf = `${profile.council.value}${profile.council.region.toUpperCase()}`;
  }
  const bodyParameters = {
    memedObj,
  };
  console.info('bodyParameters deleteMemedUser', bodyParameters);
  // return true;
  return axios.post(
    `${ROOT_URL}/deleteMemedUser`,
    bodyParameters,
    config,
  );
}

export function* deleteMemedUserRequest() {
  yield takeEvery(actions.DELETE_MEMED_USER_REQUEST, function* (action) {
    try {
      console.info('DELETE_MEMED_USER_REQUEST', action);
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const healthProfessional = yield select(getHealthProfessionalFromStore);
      const customUsers = yield select(getCustomUserFromStore);
      let profile = yield select(getProfileFromStore);
      if (_.isEmpty(profile)) {
        yield take(profileActions.PROFILE_INFO_SUCCESS);
        profile = yield select(getProfileFromStore);
      }
      if (mainUser) {
        const customHealthProfessionalProfile = yield select(getCustomHealthProfessionalProfileFromStore);
        if (!_.isEmpty(customHealthProfessionalProfile)) {
          profile = _.cloneDeep(customHealthProfessionalProfile);
        } else if (action.payload?.id && !healthProfessional) {
          // It is a non-professional account. Need to use the id provided through paylad.
          const selectedId = action.payload.id;
          if (selectedId === mainUser) {
            // Use the main profile.
          } else {
            const foundUser = customUsers.find((el) => el.id === selectedId);
            if (foundUser) {
              profile = _.cloneDeep(foundUser);
            }
          }
        }
      }
      const response = yield call(
        deleteMemedUser,
        idToken,
        mainUser,
        profile,
      );
      console.info('response deleteMemedUser', response);
      // if (response?.data?.data?.attributes) {
      //   yield put({
      //     type: actions.GET_MEMED_USER_REQUEST,
      //   });
      // }
      yield all([
        put({
          type: actions.DELETE_MEMED_USER_SUCCESS,
        }),
        put({
          type: actions.GET_MEMED_USER_REQUEST,
        }),
      ]);
      // yield put({
      //   type: actions.GET_MEMED_USER_REQUEST,
      // });
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.ERROR_UPDATING_MEMED_USER,
      });
    }
  });
}

function getProfessionalInfoFromDB(uid) {
  const fs = getFirestore();
  const docRef = doc(fs, 'professionals', uid);
  return getDoc(docRef);
}

function getUserEmail(
  idToken,
  uid,
) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    uid,
  };
  // return true;
  return axios.post(
    `${ROOT_URL}/getUserEmail`,
    bodyParameters,
    config,
  );
}

function updateMemedUser(
  idToken,
  mainUser,
  addressUid,
  profile,
  {
    external_id: oldExternalId,
    doNotChangeExternalId = false,
    updateCrm = false,
    updateEmail = false,
    updateCpf = false,
    currentMemedProfile = {},
  },
) {
  const uid = profile.id;
  // let uid;
  // if (mainUser) {
  //   uid = mainUser;
  // } else {
  //   const { currentUser } = firebase.auth();
  //   ({ uid } = currentUser);
  // }
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const memedObj = {};
  memedObj.nome = profile.firstName;
  memedObj.sobrenome = profile.lastName;
  memedObj.data_nascimento = profile.birthday;
  if (updateCpf) {
    memedObj.cpf = profile.cpf;
  }
  if (updateEmail) {
    memedObj.email = profile.email;
  }
  // memedObj.email = null;
  if (profile.gender === 'male') {
    memedObj.sexo = 'M';
  } else if (profile.gender === 'female') {
    memedObj.sexo = 'F';
  } else {
    memedObj.sexo = '';
  }
  if (profile.council?.type === 'crm' || profile.council?.type === 'cro' || profile.council?.type === 'coren') {
    if (updateCrm) {
      memedObj.board = {};
      memedObj.board.board_code = profile.council.type;
      memedObj.board.board_number = profile.council.value;
      memedObj.board.board_state = profile.council.region.toUpperCase();
    } else {
      // memedObj.uf = profile.council.region.toUpperCase();
    }
    memedObj.especialidades = profile.council.specialties;
  }
  const addressObj = profile.addresses.find((ad) => ad.id === addressUid);
  if (addressObj) {
    if (addressObj.city?.longName) {
      memedObj.cidade = addressObj.city.longName;
    }
    if (addressObj.state?.shortName) {
      memedObj.estado = addressObj.state.shortName;
    }
  }
  const bodyParameters = {
    uid,
    old_external_id: oldExternalId,
    doNotChangeExternalId,
    memedObj,
    currentMemedProfile,
  };
  console.info('bodyParameters updateMemedUser', bodyParameters);
  // return true;
  return axios.post(
    `${ROOT_URL}/updateMemedUser`,
    bodyParameters,
    config,
  );
}

export function* updateMemedUserRequest() {
  yield takeEvery(actions.UPDATE_MEMED_USER_REQUEST, function* (action) {
    const deletedMemedUser = yield select(getDeletedMemedUserFromStore);
    try {
      console.info('UPDATE_MEMED_USER_REQUEST', action);
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const healthProfessional = yield select(getHealthProfessionalFromStore);
      // const customUsers = yield select(getCustomUserFromStore);
      // const user = yield select(getUserFromStore);
      let profile = yield select(getProfileFromStore);
      if (_.isEmpty(profile)) {
        yield take(profileActions.PROFILE_INFO_SUCCESS);
        profile = yield select(getProfileFromStore);
      }
      const { addresses } = profile;
      if (mainUser) {
        const customHealthProfessionalProfile = yield select(getCustomHealthProfessionalProfileFromStore);
        if (!_.isEmpty(customHealthProfessionalProfile)) {
          profile = _.cloneDeep(customHealthProfessionalProfile);
          profile.addresses = _.cloneDeep(addresses);
        } else if (action.payload?.id && !healthProfessional) {
          // It is a non-professional account. Need to use the id provided through paylad.
          const selectedId = action.payload.id;
          if (selectedId === mainUser) {
            // Use the main profile.
          } else {
            const professionalProfile = yield call(getProfessionalInfoFromDB, selectedId);
            if (professionalProfile.exists()) {
              profile = {
                ...professionalProfile.data(),
                id: professionalProfile.id,
              };
              profile.addresses = _.cloneDeep(addresses);
            } else {
              profile = {};
            }
            // const foundUser = customUsers.find((el) => el.id === selectedId);
            // if (foundUser) {
            //   profile = _.cloneDeep(foundUser);
            //   profile.addresses = _.cloneDeep(addresses);
            // }
          }
        }
      }
      const responseEmail = yield call(getUserEmail, idToken, profile.id);
      const response = yield call(
        updateMemedUser,
        idToken,
        mainUser,
        addressUid,
        {
          ...profile,
          email: responseEmail.data,
        },
        action.payload,
      );
      if (response?.data?.data?.attributes) {
        yield put({
          type: actions.GET_MEMED_USER_REQUEST,
          payload: {
            updated: true,
            id: action?.payload?.id,
          },
        });
      }
    } catch (error) {
      console.warn(error);
      if (error?.response?.data?.errors && !deletedMemedUser) {
        // yield put({
        //   type: actions.DELETE_MEMED_USER_REQUEST,
        // });
      }
      const boardError = error?.response?.data?.errors?.find((el) => el.code === 'Board');
      if (boardError?.detail.includes('Cadastro do profissional com') && boardError?.detail.includes('já existe, com o id externo')) {
        notification(
          'error',
          'Ocorreu um erro com a Memed na hora de atualizar o seu cadastro, entre em contato com o suporte',
          <div>
            <div>
              {`Mensagem de erro: ${boardError.detail}`}
            </div>
            <div>
              <a href="https://ajuda.memed.com.br" target="_blank" rel="noopener noreferrer">Suporte Memed</a>
            </div>
          </div>,
          null,
        );
      }
      // if (action.payload.updateEmail) {
      //   // The requested email already is on use. Need to contact Memed support.
      //   notification(
      //     'warning',
      //     'O seu e-mail já está em uso em outra conta Memed, entre em contato com o suporte',
      //     <a href="https://ajuda.memed.com.br" target="_blank" rel="noopener noreferrer">Suporte Memed</a>,
      //     // null,
      //   );
      // } else
      const cpfError = error?.response?.data?.errors?.find((el) => el.code === 'CPF');
      if (cpfError) {
        notification(
          'error',
          'Ocorreu um erro com a Memed na hora de validar o seu CPF, entre em contato com o suporte',
          <div>
            <div>
              {`Mensagem de erro: ${cpfError.detail}`}
            </div>
            <div>
              <a href="https://ajuda.memed.com.br" target="_blank" rel="noopener noreferrer">Suporte Memed</a>
            </div>
          </div>,
          null,
        );
      }
      if (!boardError && !cpfError && error?.response?.data?.errors?.length > 0) {
        notification(
          'error',
          'Ocorreu um erro com a Memed na hora de realizar seu cadastro, entre em contato com o suporte',
          <div>
            {error.response.data.errors.map((e) => (
              <div key={`${e.code}-${e.detail}`}>
                {`• ${e.detail}`}
              </div>
            ))}
            <div>
              <a href="https://ajuda.memed.com.br" target="_blank" rel="noopener noreferrer">Suporte Memed</a>
            </div>
          </div>,
          null,
        );
      }
      yield put({
        type: actions.ERROR_UPDATING_MEMED_USER,
      });
    }
  });
}

function getMemedUser(idToken, mainUser, profile, field = 'uid') {
  // let uid;
  // if (mainUser) {
  //   uid = mainUser;
  // } else {
  //   const { currentUser } = firebase.auth();
  //   ({ uid } = currentUser);
  // }
  const uid = profile.id;
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    field,
    // uid: profile.cpf || UID_TESTE,
    // uid: profile.cpf || uid,
  };
  if (field === 'cpf') {
    bodyParameters.uid = profile.cpf;
  } else if (field === 'council') {
    if (profile.council?.type === 'crm' || profile.council?.type === 'cro' || profile.council?.type === 'coren') {
      const councilValue = profile.council.value
        .replace(/\s+/g, ' ')
        .replace(/^\s+|\s+$/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^0-9]/g, '');
      const council = `${councilValue}${profile.council.region.toUpperCase()}`;
      bodyParameters.uid = council;
    } else {
      bodyParameters.uid = uid;
    }
  } else {
    bodyParameters.uid = uid;
  }
  console.info('bodyParameters getMemedUser', bodyParameters);
  return axios.post(
    `${ROOT_URL}/getMemedUser`,
    bodyParameters,
    config,
  );
}

export function* getMemedUserRequest() {
  yield takeLatest([
    actions.GET_MEMED_USER_REQUEST,
    // profileActions.PROFILE_INFO_SUCCESS,
  ], function* (action) {
    let profile;
    try {
      console.info('GET_MEMED_USER_REQUEST', action);
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const memedSettings = yield select(getMemedSettingsFromStore);
      // const healthProfessional = yield select(getHealthProfessionalFromStore);
      // const customUsers = yield select(getCustomUserFromStore);
      // const user = yield select(getUserFromStore);
      profile = yield select(getProfileFromStore);
      if (_.isEmpty(profile)) {
        yield take(profileActions.PROFILE_INFO_SUCCESS);
        profile = yield select(getProfileFromStore);
      }
      const { addresses } = profile;
      if (mainUser) {
        profile = null;
        const customHealthProfessionalProfile = yield select(getCustomHealthProfessionalProfileFromStore);
        if (!_.isEmpty(customHealthProfessionalProfile)) {
          profile = _.cloneDeep(customHealthProfessionalProfile);
        }
        // else if (action.payload?.id && !healthProfessional) {
        //   // It is a non-professional account. Need to use the id provided through paylad.
        //   const selectedId = action.payload.id;
        //   if (selectedId === mainUser) {
        //     // Use the main profile.
        //   } else {
        //     const professionalProfile = yield call(getProfessionalInfoFromDB, selectedId);
        //     if (professionalProfile.exists()) {
        //       profile = {
        //         ...professionalProfile.data(),
        //         id: professionalProfile.id,
        //       };
        //       profile.addresses = _.cloneDeep(addresses);
        //     } else {
        //       profile = {};
        //     }
        //   }
        // }
      }
      if (action.payload?.id) {
        // Need to use the id provided through paylad.
        const selectedId = action.payload.id;
        if (selectedId === mainUser) {
          // Use the main profile.
          profile = yield select(getProfileFromStore);
        } else {
          const professionalProfile = yield call(getProfessionalInfoFromDB, selectedId);
          if (professionalProfile.exists()) {
            profile = {
              ...professionalProfile.data(),
              id: professionalProfile.id,
            };
            profile.addresses = _.cloneDeep(addresses);
          } else {
            profile = {};
          }
          // const foundUser = customUsers.find((el) => el.id === selectedId);
          // if (foundUser) {
          //   profile = _.cloneDeep(foundUser);
          // }
        }
      }
      console.info('profile', profile);
      console.info('memedSettings', memedSettings);
      // let numberOfMemedUsers = 0;
      // if (memedSettings) {
      //   numberOfMemedUsers = Object.keys(memedSettings).length;
      // }
      if (profile?.id && memedSettings?.[profile.id]?.useMemed) {
        const responseEmail = yield call(getUserEmail, idToken, profile.id);
        let response;
        if (action.payload?.field) {
          // If payload has 'field', it means it is a subsequent fetch try
          response = yield call(getMemedUser, idToken, mainUser, profile, action.payload.field);
        } else {
          response = yield call(getMemedUser, idToken, mainUser, profile);
        }
        console.info('response memed', response);
        if (response?.data?.data?.attributes?.external_id !== profile.id
          && response.data.data.attributes.external_id) {
          // The user retrieved using CPF/CRM does not have Meagenda's id as external_id set.
          // Need to update it using https PATCH request.
          console.info("The user retrieved using CPF/CRM does not have Meagenda's id as external_id set.");
          console.info('Need to update it using https PATCH request.');
          yield put({
            type: actions.UPDATE_MEMED_USER_REQUEST,
            payload: {
              external_id: response.data.data.attributes.external_id,
              id: profile.id,
              currentMemedProfile: response.data.data.attributes,
            },
          });
          return;
        }
        let validCrm = true;
        if ((profile.council?.type === 'crm' || profile.council?.type === 'cro' || profile.council?.type === 'coren') && profile.council?.value) {
          const councilValue = profile.council.value
            .replace(/\s+/g, ' ')
            .replace(/^\s+|\s+$/g, '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^0-9]/g, '');
          if (response?.data?.data?.attributes?.board?.board_number !== councilValue
            && response.data.data.attributes.external_id) {
            // The user retrieved has different CRM saved on Memed profile, need to update it.
            console.info('The user retrieved has different CRM saved on Memed profile, need to update it.');
            validCrm = false;
            yield put({
              type: actions.UPDATE_MEMED_USER_REQUEST,
              payload: {
                external_id: response.data.data.attributes.external_id,
                doNotChangeExternalId: true,
                updateCrm: true,
                id: profile.id,
                currentMemedProfile: response.data.data.attributes,
              },
            });
            return;
          }
          if (response?.data?.data?.attributes?.cpf !== profile.cpf
            && response.data.data.attributes.external_id) {
            // The user retrieved has different CPF saved on Memed profile, need to update it.
            console.info('The user retrieved has different CPF saved on Memed profile, need to update it.');
            yield put({
              type: actions.UPDATE_MEMED_USER_REQUEST,
              payload: {
                external_id: response.data.data.attributes.external_id,
                doNotChangeExternalId: true,
                updateCpf: true,
                id: profile.id,
                currentMemedProfile: response.data.data.attributes,
              },
            });
            return;
          }
          if (response?.data?.data?.attributes?.email !== responseEmail.data
            && response.data.data.attributes.external_id) {
            // The user retrieved has different email saved on Memed profile, need to update it.
            console.info('The user retrieved has different email saved on Memed profile, need to update it.');
            yield put({
              type: actions.UPDATE_MEMED_USER_REQUEST,
              payload: {
                external_id: response.data.data.attributes.external_id,
                doNotChangeExternalId: true,
                updateEmail: true,
                id: profile.id,
                currentMemedProfile: response.data.data.attributes,
              },
            });
            return;
          }
          if (response?.data?.data?.attributes?.data_nascimento !== profile.birthday
            && response.data.data.attributes.external_id) {
            // The user retrieved has different birthday saved on Memed profile, need to update it.
            console.info('The user retrieved has different birthday saved on Memed profile, need to update it.');
            yield put({
              type: actions.UPDATE_MEMED_USER_REQUEST,
              payload: {
                external_id: response.data.data.attributes.external_id,
                doNotChangeExternalId: true,
                id: profile.id,
                currentMemedProfile: response.data.data.attributes,
              },
            });
            return;
          }
          if (validCrm
            && response?.data?.data?.attributes?.token
            && (response?.data?.data?.attributes?.status === 'Ativo' || response?.data?.data?.attributes?.status === 'Em análise')) {
            yield put({
              type: actions.SET_MEMED_USER_TOKEN,
              payload: {
                token: response.data.data.attributes.token,
                user: response.data.data.attributes,
              },
            });
            let message = 'Conta Memed conectada com sucesso!';
            if (action?.payload?.updated) {
              message = 'As informações do seu cadastro Memed foram atualizadas';
            }
            notification(
              'success',
              message,
            );
          }
        } else {
          throw new Error('No valid council.');
        }
      }
    } catch (error) {
      console.warn(error);
      if (error?.message === 'No valid council.') {
        notification(
          'error',
          'Somente contas com CRM, CRO ou COREN podem utilizar o módulo de prescrição da Memed',
        );
        yield put({
          type: actions.ERROR_UPDATING_MEMED_USER,
        });
      } else if (!action?.payload?.field) {
        // It was not possible to fetch user using external_id, probably the user already exists
        // with the CPF informed.
        // Need to fetch user again, this time using the CPF itself as param.
        console.info('It was not possible to fetch user using external_id, probably the user already exists with the CPF informed.');
        console.info('Need to fetch user again, this time using the CPF itself as param.');
        yield put({
          type: actions.GET_MEMED_USER_REQUEST,
          payload: {
            field: 'cpf',
            id: action?.payload?.id,
          },
        });
      } else if (action?.payload?.field && action?.payload?.field !== 'council') {
        // It was not possible to fetch user using external_id and CPF, last one to try is
        // using the council number.
        // Need to fetch user again, this time using the council as param.
        console.info('It was not possible to fetch user using external_id and CPF, last one to try is using the council number.');
        console.info('Need to fetch user again, this time using the council as param.');
        yield put({
          type: actions.GET_MEMED_USER_REQUEST,
          payload: {
            field: 'council',
            id: action?.payload?.id,
          },
        });
      } else {
        // Could not find any user using external_id, CPF or council, proceed to register account.
        console.info('Could not find any user using external_id, CPF or council, proceed to register account.');
        yield put({
          type: actions.REGISTER_MEMED_USER_REQUEST,
          payload: {
            id: action?.payload?.id,
          },
        });
      }
      // else if (!action?.payload?.field) {
      //   // It was not possible to fetch user using external_id, probably the user already exists
      //   // with the CPF informed.
      //   // Need to fetch user again, this time using the CPF itself as param.
      //   console.info('It was not possible to fetch user using external_id, probably the user already exists with the CPF informed.');
      //   console.info('Need to fetch user again, this time using the CPF itself as param.');
      //   yield put({
      //     type: actions.GET_MEMED_USER_REQUEST,
      //     payload: {
      //       field: 'cpf',
      //       id: action?.payload?.id,
      //     },
      //   });
      // } else if (error?.response?.status === 404) {
      //   // Could not find any user with this CPF, proceed to register account.
      //   console.info('Could not find any user with this CPF, proceed to register account');
      //   yield put({
      //     type: actions.REGISTER_MEMED_USER_REQUEST,
      //     payload: {
      //       id: action?.payload?.id,
      //     },
      //   });
      // }
    }
  });
}

function saveMemedPrescriptionOnDB(
  fullObj,
  prescription,
  seectedId,
  memedUserData,
  // timestamp,
  addressUid,
  unified = {},
  mainProfile = null,
  mainUser,
  customUsers,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  const auth = getAuth();
  const { currentUser } = auth;
  if (mainUser) {
    uid = mainUser;
  } else {
    ({ uid } = currentUser);
  }
  const currentUid = currentUser.uid;
  const author = {};
  if (currentUid === mainProfile.id) {
    // It is the main account.
    author.firstName = mainProfile.firstName;
    author.lastName = mainProfile.lastName;
    author.uid = mainProfile.id;
  } else {
    // It is some of the 'customUsers' accounts.
    const foundProfile = customUsers.find((el) => el.id === currentUid);
    if (foundProfile) {
      author.firstName = foundProfile.firstName;
      author.lastName = foundProfile.lastName;
      author.uid = foundProfile.id;
      if (foundProfile.healthProfessional) {
        // It is a health professional account.
      } else {
        // Secretary account.
        author.notHealthProfessional = true;
      }
    }
  }
  const updates = {};
  const timestamp = moment(fullObj.created_at, 'DD/MM/YYYY HH:mm:ss').tz('America/Sao_Paulo');
  const prescriptionDate = fullObj.prescriptionDateOriginal;
  let pushKey = '';
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    pushKey = push(child(ref(db), `unified/${unified.id}/memed/${seectedId}`)).key;
  } else {
    pushKey = push(child(ref(db), `users/${uid}/memed/${seectedId}`)).key;
  }
  const prescriptionArr = [];
  const exameArr = [];
  const customArr = [];
  prescription.forEach((el) => {
    if (el.tipo !== 'custom' && el.tipo !== 'exame') {
      prescriptionArr.push(el);
    }
    if (el.tipo === 'exame') {
      exameArr.push({
        codigo: '',
        formattedTerminologia: `${el.nome}${el.sanitized_posology ? `, ${el.sanitized_posology}` : ''}`,
        id: el.id,
        terminologia: `${el.nome}${el.sanitized_posology ? `, ${el.sanitized_posology}` : ''}`,
        value: `${el.nome}${el.sanitized_posology ? `, ${el.sanitized_posology}` : ''}`,
      });
    }
    if (el.tipo === 'custom') {
      customArr.push(el);
    }
  });
  if (prescriptionArr.length > 0) {
    if (unified.id && unified.address.some((a) => a === addressUid)) {
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/timestamp`] = timestamp.format();
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/memed`] = true;
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/prescriptionDate`] = prescriptionDate;
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/memedId`] = fullObj.id;
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/items`] = _.orderBy(prescriptionArr, ['key'], ['asc']);
      updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/externalId`] = memedUserData?.external_id || null;
      if (!_.isEmpty(author)) {
        author.unified = true;
        updates[`unified/${unified.id}/prescriptions/${seectedId}/${pushKey}/professional`] = author;
      }
    } else {
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/timestamp`] = timestamp.format();
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/memed`] = true;
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/prescriptionDate`] = prescriptionDate;
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/memedId`] = fullObj.id;
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/items`] = _.orderBy(prescriptionArr, ['key'], ['asc']);
      updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/externalId`] = memedUserData?.external_id || null;
      if (!_.isEmpty(author)) {
        updates[`users/${uid}/prescriptions/${seectedId}/${pushKey}/professional`] = author;
      }
    }
  }
  if (exameArr.length > 0) {
    if (unified.id && unified.address.some((a) => a === addressUid)) {
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/timestamp`] = timestamp.format();
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/memed`] = true;
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/prescriptionDate`] = prescriptionDate;
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/memedId`] = fullObj.id;
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/exam`] = _.orderBy(exameArr, ['value'], ['asc']);
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/externalId`] = memedUserData?.external_id || null;
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/mode`] = 'exam';
      updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/observation`] = '';
      if (!_.isEmpty(author)) {
        author.unified = true;
        updates[`unified/${unified.id}/exams/${seectedId}/finalized/${pushKey}/professional`] = author;
      }
    } else {
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/timestamp`] = timestamp.format();
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/memed`] = true;
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/prescriptionDate`] = prescriptionDate;
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/memedId`] = fullObj.id;
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/exam`] = _.orderBy(exameArr, ['value'], ['asc']);
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/externalId`] = memedUserData?.external_id || null;
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/mode`] = 'exam';
      updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/observation`] = '';
      if (!_.isEmpty(author)) {
        updates[`users/${uid}/exams/${seectedId}/finalized/${pushKey}/professional`] = author;
      }
    }
  }
  if (customArr.length > 0) {
    customArr.forEach((el) => {
      const newOps = {
        ops: [{
          insert: `${el.nome}\n${el.description ? `${el.description}` : ''}\n${el.sanitized_posology ? `${el.sanitized_posology}` : ''}`,
        }],
      };
      if (unified.id && unified.address.some((a) => a === addressUid)) {
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/timestamp`] = timestamp.format();
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/memed`] = true;
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/prescriptionDate`] = prescriptionDate;
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/memedId`] = fullObj.id;
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
        // updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/exam`] = _.orderBy(exameArr, ['value'], ['asc']);
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/externalId`] = memedUserData?.external_id || null;
        updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/text`] = newOps;
        if (!_.isEmpty(author)) {
          author.unified = true;
          updates[`unified/${unified.id}/otherDocuments/${seectedId}/${pushKey}/professional`] = author;
        }
      } else {
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/timestamp`] = timestamp.format();
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/memed`] = true;
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/prescriptionDate`] = prescriptionDate;
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/memedId`] = fullObj.id;
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
        // updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/exam`] = _.orderBy(exameArr, ['value'], ['asc']);
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/externalId`] = memedUserData?.external_id || null;
        updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/text`] = newOps;
        if (!_.isEmpty(author)) {
          updates[`users/${uid}/otherDocuments/${seectedId}/${pushKey}/professional`] = author;
        }
      }
    });
  }
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/timestamp`] = timestamp.format();
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/memed`] = true;
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/prescriptionDate`] = prescriptionDate;
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/memedId`] = fullObj.id;
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/items`] = _.orderBy(prescription, ['key'], ['asc']);
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/externalId`] = memedUserData?.external_id || null;
    if (!_.isEmpty(author)) {
      author.unified = true;
      updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/professional`] = author;
    }
  } else {
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/timestamp`] = timestamp.format();
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/queryTimestamp`] = -1 * parseInt(timestamp.format('x'), 10);
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/memed`] = true;
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/prescriptionDate`] = prescriptionDate;
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/memedId`] = fullObj.id;
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/prescriptionUuid`] = fullObj.prescriptionUuid;
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/items`] = _.orderBy(prescription, ['key'], ['asc']);
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/externalId`] = memedUserData?.external_id || null;
    if (!_.isEmpty(author)) {
      updates[`users/${uid}/memed/${seectedId}/${pushKey}/professional`] = author;
    }
  }
  // return true;
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

function normalizePrescription(presc) {
  const arr = [];
  if (presc.medicamentos) {
    presc.medicamentos.forEach((el) => {
      arr.push(el);
    });
  }
  return arr;
}

export function* saveMemedPrescription() {
  yield takeEvery(actions.SAVE_MEMED_PRESCRIPTION_REQUEST, function* (action) {
    try {
      let profile = yield select(getProfileFromStore);
      if (_.isEmpty(profile)) {
        yield take(profileActions.PROFILE_INFO_SUCCESS);
        profile = yield select(getProfileFromStore);
      }
      const { values } = action.payload;
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const customUsers = yield select(getCustomUserFromStore);
      const memedUserData = yield select(getMemedUserDataFromStore);
      const prescription = yield call(normalizePrescription, values.prescricao);
      yield call(
        saveMemedPrescriptionOnDB,
        values.prescricao,
        prescription,
        values.prescricao.paciente.external_id,
        memedUserData,
        addressUid,
        unified,
        profile,
        mainUser,
        customUsers,
      );
      yield all([
        put({
          type: actions.PATIENT_MEMED_FETCH_REQUEST,
        }),
        // yield put({
        //   type: actions.RESET_PRESCRIPTION,
        //   payload: {
        //     id: seectedId,
        //   },
        // }),
        // yield put({
        //   type: appActions.CHANGE_SPECIFIC_SAVED_ALL_CHANGES_FIELD,
        //   payload: {
        //     id: seectedId,
        //     field: 'prescription',
        //     fieldValue: true,
        //   },
        // }),
      ]);
    } catch (error) {
      console.warn(error);
      notification(
        'error',
        'Não foi possível salvar a receita Memed em seu histórico do Meagenda',
        'A prescrição gerada ainda estará salva no histórico do paciente ao acessar os módulos Memed.',
      );
    }
  });
}

function getMemedPrescriptionPdf(idToken, mainUser, memedUserToken, memedId) {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const bodyParameters = {
    // uid,
    memedUserToken,
    memedId,
  };
  return axios.post(
    `${ROOT_URL}/getMemedPrescriptionPdf`,
    bodyParameters,
    config,
  );
}

export function* getMemedPrescriptionPdfRequest() {
  yield takeEvery(actions.GET_MEMED_PRESCRIPTION_PDF_REQUEST, function* (action) {
    try {
      yield put({ type: actions.DOWNLOADING_MEMED_PRESCRIPTION_PDF });
      const idToken = yield call(getIdToken);
      const mainUser = yield select(getMainUserFromStore);
      const memedUserToken = yield select(getMemedUserTokenFromStore);
      const response = yield call(
        getMemedPrescriptionPdf,
        idToken,
        mainUser,
        memedUserToken,
        action.payload.memedId,
      );
      if (response?.data?.data) {
        const arr = [];
        response.data.data.forEach((el) => {
          if (el.attributes?.link) {
            arr.push({
              url: el.attributes.link,
              id: action.payload.id,
              type: 'application/pdf',
            });
          }
        });
        yield put({
          type: actions.GET_MEMED_PRESCRIPTION_PDF_SUCCESS,
          payload: arr,
        });
      } else {
        throw new Error('Failed to fetch prescription.');
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.GET_MEMED_PRESCRIPTION_PDF_ERROR,
      });
      if (error?.response?.data?.errors?.find((el) => el.detail === 'Prescrição não encontrada')) {
        notification(
          'warning',
          'A prescrição não foi encontrada com a conta conectada',
          'Talvez a entrada tenha sido gerada com outra conta Memed.',
          10,
        );
      }
    }
  });
}

function fetchMemedPrescriptionFromDB(addressUid, mainUser, unified = {}, seectedId, memedId) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    const databaseRef = ref(db, `unified/${unified.id}/prescriptions/${seectedId}`);
    return get(dbQuery(
      databaseRef,
      orderByChild('memedId'),
      equalTo(memedId),
    ));
    // return db.ref(`unified/${unified.id}/prescriptions/${seectedId}`)
    //   .orderByChild('memedId')
    //   .equalTo(memedId)
    //   .once('value');
  }
  const databaseRef = ref(db, `users/${uid}/prescriptions/${seectedId}`);
  return get(dbQuery(
    databaseRef,
    orderByChild('memedId'),
    equalTo(memedId),
  ));
  // return db.ref(`users/${uid}/prescriptions/${seectedId}`)
  //   .orderByChild('memedId')
  //   .equalTo(memedId)
  //   .once('value');
}

function removeMemedPrescriptionFromDB(addressUid, mainUser, unified = {}, seectedId, id) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    updates[`unified/${unified.id}/memed/${seectedId}/${id}`] = null;
  } else {
    updates[`users/${uid}/memed/${seectedId}/${id}`] = null;
  }
  return update(dbRef, updates);
  // return new Promise((resolve, reject) => {
  //   db.ref().update(updates, (error) => {
  //     if (error) {
  //       reject(new Error(error));
  //     } else {
  //       resolve(true);
  //     }
  //     return null;
  //   });
  // });
}

export function* removeMemedPrescriptionRequest() {
  yield takeEvery(actions.REMOVE_MEMED_PRESCRIPTION_REQUEST, function* (action) {
    try {
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const seectedId = yield select(getSeectedIdFromStore);
      const prescription = yield call(
        fetchMemedPrescriptionFromDB,
        addressUid,
        mainUser,
        unified,
        seectedId,
        action.payload,
      );
      if (prescription.exists()) {
        let key = null;
        Object.keys(prescription.val()).forEach((id) => {
          key = id;
        });
        yield call(
          removeMemedPrescriptionFromDB,
          addressUid,
          mainUser,
          unified,
          seectedId,
          key,
        );
        yield put({
          type: prescriptionsActions.PATIENT_PRESCRIPTIONS_FETCH_REQUEST,
        });
      }
    } catch (error) {
      console.warn(error);
      yield put({
        type: actions.REMOVE_MEMED_PRESCRIPTION_ERROR,
      });
    }
  });
}

function getMemedListFromDB(seectedId, addressUid, unified = {}, mainUser, lastItem) {
  const db = getDatabase();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    if (lastItem) {
      const databaseRef = ref(db, `unified/${unified.id}/memed/${seectedId}`);
      return get(dbQuery(
        databaseRef,
        orderByChild('queryTimestamp'),
        startAt(lastItem.queryTimestamp, lastItem.id),
        limitToFirst(6),
      ));
    }
    const databaseRef = ref(db, `unified/${unified.id}/memed/${seectedId}`);
    return get(dbQuery(
      databaseRef,
      orderByChild('queryTimestamp'),
      limitToFirst(5),
    ));
  }
  if (lastItem) {
    const databaseRef = ref(db, `users/${uid}/memed/${seectedId}`);
    return get(dbQuery(
      databaseRef,
      orderByChild('queryTimestamp'),
      startAt(lastItem.queryTimestamp, lastItem.id),
      limitToFirst(6),
    ));
  }
  const databaseRef = ref(db, `users/${uid}/memed/${seectedId}`);
  return get(dbQuery(
    databaseRef,
    orderByChild('queryTimestamp'),
    limitToFirst(5),
  ));
}

export function* getMemedList() {
  yield takeEvery(actions.PATIENT_MEMED_FETCH_REQUEST, function* (action) {
    try {
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      const seectedId = yield select(getSeectedIdFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const lastMemedItemFromStore = yield select(getLastMemedItemFromStore);
      const currentMemedList = yield select(getMemedListFromStore);
      let lastMemedListPagination = null;
      if (lastMemedItemFromStore[seectedId] && action?.payload?.paginate) {
        lastMemedListPagination = lastMemedItemFromStore[seectedId];
      }
      const memedList = yield call(
        getMemedListFromDB,
        seectedId,
        addressUid,
        unified,
        mainUser,
        lastMemedListPagination,
      );
      const memedArray = [];
      memedList.forEach((el) => {
        memedArray.push({
          ...el.val(),
          id: el.key,
          key: el.val().timestamp || el.key,
        });
      });
      const lastMemedItem = memedArray[memedArray.length - 1];

      if (lastMemedListPagination && currentMemedList[seectedId]) {
        yield put({
          type: actions.PATIENT_MEMED_FETCH_SUCCESS,
          payload: {
            memedList: { ...currentMemedList[seectedId], ...memedList.val() },
            id: seectedId,
            lastMemedItem,
            noNextMemedListPage: memedArray.length < 5,
          },
        });
      } else {
        yield put({
          type: actions.PATIENT_MEMED_FETCH_SUCCESS,
          payload: {
            memedList: memedList.val(),
            id: seectedId,
            lastMemedItem,
            noNextMemedListPage: memedArray.length < 5,
          },
        });
      }
    } catch (error) {
      console.warn(error);
    }
  });
}

function saveCollapseMemedItemOnDB(
  value,
  pushKey,
  seectedId,
  addressUid,
  unified = {},
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/collapse`] = value;
  } else {
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/collapse`] = value;
  }
  // return true;
  return update(dbRef, updates);
}

export function* collapseMemedItem() {
  yield takeLatest(actions.CHANGE_COLLAPSE_MEMED_ITEM_REQUEST, function* (action) {
    try {
      const seectedId = yield select(getSeectedIdFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      yield call(sleep, 3000);
      yield call(
        saveCollapseMemedItemOnDB,
        action.payload.value,
        action.payload.id, // pushKey
        seectedId,
        addressUid,
        unified,
        mainUser,
      );
    } catch (error) {
      console.warn(error);
      notification('warning', 'Sua conexão com a internet está instável.');
    }
  });
}

function saveHideMemedItemOnDB(
  value,
  pushKey,
  seectedId,
  addressUid,
  unified = {},
  mainUser,
) {
  const db = getDatabase();
  const dbRef = ref(db);
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const updates = {};
  if (unified.id && unified.address.some((a) => a === addressUid)) {
    updates[`unified/${unified.id}/memed/${seectedId}/${pushKey}/hidden`] = value;
  } else {
    updates[`users/${uid}/memed/${seectedId}/${pushKey}/hidden`] = value;
  }
  // return true;
  return update(dbRef, updates);
}

export function* hideMemedItem() {
  yield takeLatest(actions.CHANGE_HIDE_MEMED_ITEM_REQUEST, function* (action) {
    try {
      yield put({
        type: actions.CHANGING_HIDE_MEMED_ITEM,
        payload: action.payload.id,
      });
      const seectedId = yield select(getSeectedIdFromStore);
      const mainUser = yield select(getMainUserFromStore);
      const unified = yield select(getUnifiedTokenStore);
      const addressUid = yield select(getSelectedAddressFromStore);
      yield call(
        saveHideMemedItemOnDB,
        !action.payload.hidden,
        action.payload.id, // pushKey
        seectedId,
        addressUid,
        unified,
        mainUser,
      );
      yield put({
        type: actions.PATIENT_MEMED_FETCH_REQUEST,
      });
    } catch (error) {
      console.warn(error);
      notification('warning', 'Sua conexão com a internet está instável.');
      yield put({ type: actions.CHANGE_HIDE_MEMED_ITEM_ERROR });
    }
  });
}

export function* checkShowHiddenMemedItemsStatus() {
  yield takeEvery(actions.GET_SHOW_HIDDEN_MEMED_ITEMS_STATUS, function* () {
    try {
      const data = yield localStorage.getItem('show_hidden_memed_items');
      if (_.isNull(data)) {
        yield put({
          type: actions.GET_SHOW_HIDDEN_MEMED_ITEMS_STATUS_SUCCESS,
          value: false,
        });
      } else {
        yield put({
          type: actions.GET_SHOW_HIDDEN_MEMED_ITEMS_STATUS_SUCCESS,
          value: JSON.parse(data),
        });
      }
    } catch (error) {
      console.warn(error);
    }
  });
}

export function* setShowHiddenMemedItems() {
  yield takeEvery(actions.SET_SHOW_HIDDEN_MEMED_ITEMS, function* (action) {
    try {
      yield localStorage.setItem('show_hidden_memed_items', action.value);
      yield put({
        type: actions.GET_SHOW_HIDDEN_MEMED_ITEMS_STATUS,
      });
    } catch (error) {
      console.warn(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getMememedSettingsRequest),
    fork(changeUseMemedRequest),
    fork(registerMemedUserRequest),
    fork(deleteMemedUserRequest),
    fork(getMemedUserRequest),
    fork(updateMemedUserRequest),
    // fork(initMemedEventsRequest),
    fork(saveMemedPrescription),
    fork(getMemedPrescriptionPdfRequest),
    fork(removeMemedPrescriptionRequest),
    fork(getMemedList),
    fork(collapseMemedItem),
    fork(hideMemedItem),
    fork(checkShowHiddenMemedItemsStatus),
    fork(setShowHiddenMemedItems),
  ]);
}
